import Vue from 'vue';

Vue.component('PatientIndexComponent', require('./components/PatientIndexComponent').default);
Vue.component('PatientGetComponent', require('./components/PatientFormComponent').default);
Vue.component('PatientsDataTable', require('./components/partials/PatientsDataTable').default);
Vue.component('PatientDetailsTabs', require('./components/partials/PatientDetailsTabs').default);
Vue.component('PatientDetailsTabsItems', require('./components/partials/PatientDetailsTabsItems').default);
Vue.component('UploadPatientFromPdfButton', require('./components/partials/UploadPatientFromPdfButton').default);
Vue.component('PatientLatestBloodResults', require('./components/partials/PatientLatestBloodResults').default);
Vue.component('PatientFormDetails', require('./components/partials/patient-details/PatientFormDetails').default);
Vue.component(
    'PatientDispensingStage',
    require('./components/partials/patient-details/PatientDispensingStage').default
);
Vue.component(
    'PatientFormHealthInformation',
    require('./components/partials/patient-details/PatientFormHealthInformation').default
);
Vue.component('PatientFormDiagnosis', require('./components/partials/patient-details/PatientFormDiagnosis').default);
Vue.component('PatientFormActions', require('./components/partials/patient-details/PatientFormActions').default);
Vue.component(
    'PatientChangeRequestDialog',
    require('./components/partials/patient-details/PatientChangeRequestDialog.vue').default
);

Vue.component(
    'BloodResultsDataTable',
    require('./components/partials/blood-results-partials/BloodResultsDataTable').default
);
Vue.component('BloodResultsForm', require('./components/partials/blood-results-partials/BloodResultsForm').default);

Vue.component('MemosDataTable', require('./components/partials/memos/MemosDataTable').default);

Vue.component('BloodResultIndexComponent', require('./components/BloodResultIndexComponent').default);
Vue.component('BloodResultDataTable', require('./components/partials/BloodResultDataTable').default);

Vue.component('UploadFromPdfIndexComponent', require('./components/UploadFromPdfIndexComponent').default);
Vue.component('UploadWidget', require('./components/partials/upload-from-pdf/UploadWidget').default);

// Dispending
Vue.component('DispensingTimeLine', require('./components/partials/dispensing/DispensingTimeLine').default);
Vue.component('DispensingActions', require('./components/partials/dispensing/DispensingActions').default);

// Dispensed Patients
Vue.component('DispensedPatientIndexComponent', require('./components/DispensedPatientIndexComponent').default);
Vue.component('DispensedPatientsDataTable', require('./components/partials/DispensedPatientsDataTable').default);

// Dispending partials
Vue.component(
    'DispensingAddNumberOfDays',
    require('./components/partials/dispensing/partials/DispensingAddNumberOfDays').default
);
Vue.component('DispensingPermitted', require('./components/partials/dispensing/partials/DispensingPermitted').default);
Vue.component(
    'DispensingPermittedPreview',
    require('./components/partials/dispensing/partials/DispensingPermittedPreview').default
);
Vue.component(
    'DispensingRestartScheduleStage',
    require('./components/partials/dispensing/partials/DispensingRestartScheduleStage').default
);

Vue.component(
    'DispensingFillAeForm',
    require('./components/partials/dispensing/partials/DispensingFillAeForm').default
);

Vue.component(
    'DispensingAddScheduleStage',
    require('./components/partials/dispensing/partials/DispensingAddScheduleStage').default
);
export const FakeTimeLineElement = {
    id: 'new',
    patient_id: null,
    memo_type: null,
    created_by_id: null,
    action: null,
    memo_date: new Date(),
    memo_text: null,
    additional_data: { type: null },
    created_at: new Date(),
    updated_at: new Date(),
};

Vue.component(
    'PatientFormAdverseEvent',
    require('./components/partials/patient-details/PatientFormAdverseEvent').default
);
Vue.component('AdverseEventDataTable', require('./components/partials/adverse-event/AdverseEventDataTable').default);
Vue.component(
    'AdverseEventFormComponent',
    require('./components/partials/adverse-event/AdverseEventFormComponent').default
);
Vue.component('MemoFormComponent', require('./components/partials/memos/MemoFormComponent').default);
